<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'todo.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateTodo"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'todo.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteTodo"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: ['todo'],
  data() {
    return {
      deleteButtonLoader: false,
      deleteConfirmVisible: false
    };
  },

  methods: {
    async deleteTodo() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('todo/delete', this.todo.id);
        this.$store.dispatch('todo/fetchAll');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },
    async updateTodo() {
      this.$router.push('/todos/update/' + this.todo.id);
    }
  }
};
</script>
